import React, {useEffect, useState} from 'react';
import { Box, Card, CardContent, Divider, Typography,Slider, Button } from '@material-ui/core';
import useStyles from "../../assets/styles/ProgramPreviewStyles";
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import { useHistory } from 'react-router-dom';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import {IconButton} from "@mui/material";
import { ArrowDropDown, ArrowDropUp } from "@material-ui/icons";
import {PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT_VERBOSE} from "../../utils/constants";
// import {Assessment} from "../../ui_library/ver_24.10/SlidesLayouts/SlideLayoutsNew.comp";
import CircularProgress from "@material-ui/core/CircularProgress";

// const questions = [
//     {
//         AssessmentID: "c1_mod1_unit1_l2_MCQ_1",
//         AssessmentType: "MCQ",
//         AssessmentQuestion: "How does multitasking primarily affect attention span compared to focusing on a single task?",
//         AnswerOptions: [
//             { OptionID: "opt1", OptionText: "It significantly decreases attention span." },
//             { OptionID: "opt2", OptionText: "It significantly increases attention span." },
//             { OptionID: "opt3", OptionText: "It has no impact on attention span." },
//             { OptionID: "opt4", OptionText: "It varies depending on the task." },
//         ],
//         CorrectAnswer: "opt1",
//     },
//     {
//         AssessmentID: "c1_mod1_unit1_l1_assessment_2",
//         AssessmentType: "TF",
//         AssessmentQuestion: "True or False: Multitasking always improves productivity.",
//         AnswerOptions: [
//             { OptionID: "opt1", OptionText: "True" },
//             { OptionID: "opt2", OptionText: "False" },
//         ],
//         CorrectAnswer: "opt2",
//     },
//     {
//         AssessmentID: "c1_mod1_unit1_l1_assessment_3",
//         AssessmentType: "MAQ",
//         AssessmentQuestion: "Which of the following is a consequence of multitasking on cognitive performance?",
//         AnswerOptions: [
//             { OptionID: "opt1", OptionText: "Decreased efficiency." },
//             { OptionID: "opt2", OptionText: "Increased error rates." },
//             { OptionID: "opt3", OptionText: "Enhanced focus." },
//             { OptionID: "opt4", OptionText: "Better memory retention." },
//         ],
//         CorrectAnswer: ["opt1", "opt2"],
//     },
//     {
//         AssessmentID: "c1_mod1_unit1_l1_assessment_4",
//         AssessmentType: "Theory",
//         AssessmentQuestion: "Explain the importance of shifting perspectives in addressing AI-related challenges.",
//         AnswerOptions: [],
//         CorrectAnswer: null,
//     },
// ];

const ProgramPreview = ({data, options, actions}) => {
    const classes = useStyles();
    const [isContentLoaded, setIsContentLoaded] = useState(false);
    const [openModules, setOpenModules] = useState({});
    const [openUnits, setOpenUnits] = useState({});
    const [selectedSession, setSelectedSession] = useState(null);
    const [selectedSection, setSelectedSection] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    const { programData, unitsData, sessionsData, modulesData, chats } = data;
    const { height, bottom, chatType } = options;
    const { sendMessageAction, fetchSessionAction, exitProgramAction } = actions;

    const [isCollapsed, setIsCollapsed] = useState(false);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const [sessionExists, setSessionExists] = useState(true);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
        if (!isCollapsed) {
            setSelectedLesson(null);
        }
    };

    useEffect(() => {
        if (sessionsData && sessionsData.length > 0) {
            setIsContentLoaded(true);
        } else {
            setIsContentLoaded(false);
        }
    }, [sessionsData]);

    const progressValue = (currentSlide / (sessionsData.length - 1)) * 100;

    const handleToggleModuleDropdown = (moduleIndex) => {
        setOpenModules((prev) => ({
            ...prev,
            [moduleIndex]: !prev[moduleIndex],
        }));
    };

    const handleToggleUnitDropdown = (moduleIndex, unitIndex) => {
        setOpenUnits((prev) => ({
            ...prev,
            [`${moduleIndex}-${unitIndex}`]: !prev[`${moduleIndex}-${unitIndex}`],
        }));
    };
    const handleViewSession = (session) => {
        if (!session.exists) return;

        setSelectedSession(null);
        let isLastSession = true;
        let found = false;

        for (const module of modulesData) {
            for (const unit of module.units) {
                for (const current of unit.lessons) {
                    if (found && current.exists) {
                        isLastSession = false;
                        break;
                    }
                    if (current.lesson_code === session.lesson_code) {
                        found = true;
                    }
                }
                if (!isLastSession) break;
            }
            if (!isLastSession) break;
        }

        fetchSessionAction(session.lesson_code).then(() => {
            setSelectedSession(session);
        });
        setIsCollapsed(true);
        setSelectedSection('Session Details');
        setCurrentSlide(0);
    };

    const handleNextSlide = () => {
        setCurrentSlide((prev) => prev + 1);
    };

    const handlePrevSlide = () => {
        setCurrentSlide((prev) => prev - 1);
    };

    if (loading) {
        return (
            <Box className={classes.loaderContainer}>
                <Loader />
            </Box>
        );
    }

    function exitProgramHandler() {
        if (!selectedSession || !modulesData.length) return;

        let foundNext = false;
        for (const module of modulesData) {
            for (const unit of module.units) {
                for (let i = 0; i < unit.lessons.length; i++) {
                    const current = unit.lessons[i];
                    if (foundNext && current.exists) {
                        handleViewSession(current);
                        return;
                    }
                    if (current.lesson_code === selectedSession.lesson_code) {
                        foundNext = true;
                    }
                }
            }
        }
        console.log("exit program");
        actions.exitProgramAction();
    }

    return (
        <Box sx={{flexDirection:{xs:'column', sm:'row'}}} style={{display: 'flex', width: '100%', minHeight: '90vh'}}>
            {/* Left Container - Curriculum List */}
            <Box className={classes.leftContainer} style={{height: isCollapsed ? '140px' : 'auto'}}>
                {loading ? (
                    <Typography>Loading...</Typography>
                ) : isCollapsed && selectedLesson ? (
                    <Box
                        style={{
                            padding: '10px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h6" className={classes.title}>
                            {selectedLesson.sessionName}
                        </Typography>
                        <IconButton onClick={toggleCollapse} style={{ marginTop: 'auto' }}>
                            <ArrowDropDown />
                        </IconButton>
                    </Box>
                ) : (
                    <>
                        <Typography variant="h4" className={classes.title} onClick={toggleCollapse}>
                            {programData.course_name}
                        </Typography>
                        {modulesData.map((module, moduleIndex) => (
                            <Card className={classes.card} key={module.module_code}>
                                <CardContent className={classes.cardContent}>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        onClick={() => handleToggleModuleDropdown(moduleIndex)}
                                        style={{cursor: 'pointer'}}
                                    >
                                        <Typography
                                            variant="h6"
                                            component="h2"
                                            style={{fontSize: '1.3rem', color: '#ED6628'}}
                                        >
                                            {`${module.module_name}`}
                                        </Typography>

                                        {openModules[moduleIndex] ? (
                                            <ArrowDropUp style={{ color: '#D35400' }} />
                                        ) : (
                                            <ArrowDropDown style={{ color: '#D35400' }} />
                                        )}
                                    </Box>

                                    {openModules[moduleIndex] && (
                                        <>
                                            {module.units.map((unit, unitIndex) => (
                                                <Card style={{boxShadow:'none'}} key={unit.unit_code}>
                                                    <CardContent>
                                                        <Box
                                                            display="flex"
                                                            alignItems="center"
                                                            justifyContent="space-between"
                                                            onClick={() => handleToggleUnitDropdown(moduleIndex, unitIndex)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Typography variant="h6" style={{ color: '#e7456d' }}>
                                            {`${unit.unit_title}`}
                                                            </Typography>
                                                            {openUnits[`${moduleIndex}-${unitIndex}`] ? (
                                                                <ArrowDropUp style={{ color: '#ED6628' }} />
                                                            ) : (
                                                                <ArrowDropDown style={{ color: '#ED6628' }} />
                                                            )}
                                                        </Box>

                                                        {openUnits[`${moduleIndex}-${unitIndex}`] && (
                                                            <>
                                                                <Divider
                                                                    style={{
                                                                        height: '4px',
                                                                        marginTop: '10px',
                                                                        backgroundColor: '#F17632',
                                                                        borderRadius: '15px',
                                                                    }}
                                                                />
                                                                {unit.lessons.map((session) => (
                                                                    <Box
                                                                        className={classes.lessonContainer}
                                                                        key={session.lesson_code}
                                                                        style={{
                                                                            paddingBottom: '8px',
                                                                            backgroundColor:
                                                                                selectedSession?.lesson_code === session.lesson_code
                                                                                    ? 'rgba(238, 102, 40, 0.15)'
                                                                                    : 'transparent',
                                                                            borderRadius:
                                                                                selectedSession?.lesson_code === session.lesson_code ? '8px' : '0px',
                                                                        }}
                                                                    >
                                                                        <Box className={classes.sectionRow}>
                                                                            <Typography
                                                                                variant="h4"
                                                                                className={classes.sectionText}
                                                                                style={{cursor: 'pointer', color: '#5A5A5A',}}
                                                                                disabled={!session.exists}
                                                                                onClick={() => handleViewSession(session)}
                                                                            >
                                                                                {`${session.lesson_title}` }
                                                                            </Typography>
                                                                            <Button
                                                                                variant="contained"
                                                                                className={classes.viewButton}
                                                                                disabled={!session.exists}
                                                                                onClick={() => handleViewSession(session)}
                                                                            >
                                                                                {!session.exists ? (
                                                                                    <CircularProgress
                                                                                        size={24}
                                                                                        style={{ color: '#EF6528' }}
                                                                                    />
                                                                                ) : (
                                                                                    "View"
                                                                                )}
                                                                            </Button>
                                                                        </Box>
                                                                    </Box>
                                                                ))}
                                                            </>
                                                        )}
                                                    </CardContent>
                                                </Card>
                                            ))}
                                        </>
                                    )}
                                </CardContent>
                            </Card>
                        ))}
                        <IconButton
                            sx={{display:{xs:'visible', sm:'none'}}}
                            style={{
                                position: 'absolute',
                                top: '115px',
                                left: '50%',
                                fontSize:'30px',
                                transform: 'translateX(-50%)',
                                color: '#F17632',
                            }}
                        >
                            {isCollapsed ? (
                                <ArrowDropDown style={{color: '#ED6628'}}/>
                            ) : (
                                <ArrowDropUp style={{color: '#ED6628'}}/>
                            )}
                        </IconButton>
                    </>
                )}
            </Box>

            {/* Right Container - Slideshow */}
            {selectedSession && selectedSection && (
            <Box className={classes.rightContainer}>
                {selectedSession && selectedSection && (
                    <Box
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%',
                            paddingTop: '35px',
                        }}
                    >
                        <Slider
                            style={{paddingBottom: '30px'}}
                            value={currentSlide}
                            min={0}
                            max={sessionsData.length - 1}
                            step={1}
                            classes={{
                                root: classes.slider,
                                track: classes.track,
                                thumb: classes.thumb,
                            }}
                            disabled
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'center',
                                padding:{xs:'0px', sm:'20px'},
                                width: {xs:'85%',sm:'100%'},
                                height: '100%',
                                position: 'relative',
                                textAlign: 'center',
                            }}
                        >
                            {sessionsData[currentSlide] && (() => {
                                const sessionSlide = sessionsData[currentSlide];

                                const SlideComponent = PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT_VERBOSE[sessionSlide.SlideLayout];

                                const slideOptions = sessionSlide.options || {};

                                return (
                                    <SlideComponent
                                        title={sessionSlide.SlideTitle}
                                        slideContent={Array.isArray(sessionSlide.SlideContent) ? sessionSlide.SlideContent : [sessionSlide.SlideContent]}
                                        images={sessionSlide.Images || []}
                                        data={data}
                                        options={{ ...options, ...slideOptions }}
                                        actions={actions}
                                        backgroundColor={slideOptions.backgroundColor || '#FFF'}
                                        height={slideOptions.height || 'auto'}
                                        showButton={slideOptions.showButton || false}
                                    />
                                );
                            })()}
                        </Box>
                    </Box>
                )}

                {currentSlide > 0 && (
                    <IconButton
                        onClick={handlePrevSlide}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '10px',
                            backgroundColor: '#ef6528',
                            color: '#fff',
                        }}
                    >
                        <ArrowBack/>
                    </IconButton>
                )}

                {isContentLoaded && sessionsData.length > 1 && currentSlide < sessionsData.length - 1 && (
                    <IconButton
                        onClick={handleNextSlide}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '10px',
                            backgroundColor: '#ef6528',
                            color: '#fff',
                        }}
                    >
                        <ArrowForward/>
                    </IconButton>
                )}

                <Button
                    onClick={exitProgramHandler}
                    style={{
                        marginTop: '25px',
                        marginBottom: '20px',
                        backgroundColor: '#ef6528',
                        color: '#fff',
                    }}
                >
                    {sessionExists ? 'Next Session' : 'Exit Program'}
                </Button>
            </Box>
                )}
        </Box>
    );
};

export default ProgramPreview;
